<template>
    <div class="content-scroll">
        <div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
                <el-tab-pane label="客户列表" name="first"></el-tab-pane>
            </el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus"
                       title="新增">新增
            </el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="company">
                    <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item label="跟踪状态" prop="customerTrackStatusId">
                    <el-select clearable size="small" filterable v-model="filters.customerTrackStatusId "
                               placeholder="请选择跟踪状态" @change="searchPage">
                        <el-option v-for="item in statusOption" :label="item.name" :value="item.id"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户等级" prop="levelId">
                    <el-select clearable size="small" filterable v-model="filters.levelId" placeholder="请选择客户等级"
                               @change="searchPage">
                        <el-option v-for="item in levelOption" :label="item.name" :value="item.id"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户来源" prop="customerSourceId">
                    <el-select clearable size="small" filterable v-model="filters.customerSourceId"
                               placeholder="请选择客户来源" @change="searchPage">
                        <el-option v-for="item in sourceOption" :label="item.name" :value="item.id"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户状态" prop="customerStatusId">
                    <el-select clearable size="small" filterable v-model="filters.customerStatusId"
                               placeholder="请选择客户状态" @change="searchPage">
                        <el-option v-for="item in customerStatusOption" :label="item.name" :value="item.id"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="跟踪日期">
                    <el-date-picker size="small" v-model="timeRange"
                                    @change="getTimeRange($event,'lastTrackTimeStart','lastTrackTimeEnd')"
                                    type="daterange" :picker-options="recentOptions" range-separator="-"
                                    start-placeholder="申请开始日期" end-placeholder="申请结束日期" align="right"></el-date-picker>
                </el-form-item>

                <el-form-item label="是否掉入公海" prop="customerStatusId">
                    <el-select v-model="filters.openSea" clearable placeholder="请选择是否调入公海">
                        <el-option
                                label="是"
                                value="true">
                        </el-option>
                        <el-option
                                label="否"
                                value="false">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="primary" @click="handleExport()">导出
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="danger" @click="handleExportTemplate()">
                        模板下载
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-upload
                            ref='import'
                            :action="root + uploadUrl"
                            :show-file-list="false"
                            :on-success="importSuccess"
                            :before-upload="beforeImportFile"
                            :on-error="handleError"
                            :headers="{'username': username }">
                        <el-button size="small" type="warning">客户导入</el-button>
                    </el-upload>
                </el-form-item>
                <template slot="header">
                    <el-button size="mini" type="" class="el-icon-s-operation" click @click="dialogFormVisible=true"/>
                </template>
            </el-form>

            <el-dialog ref="dialog__wrapper" title="显示列" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
                       :close-on-press-escape="false">
                <el-row :gutter="20">
                    <el-col
                            v-for="(item, index) in tableLabel"
                            :key="index"
                            :span="6"
                            style="height:35px"
                    >
                        <el-checkbox v-model="item.show">{{ item.label }}</el-checkbox>
                    </el-col>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button type="danger" size="mini" @click="dialogFormVisible = false">取消</el-button>
                </div>
            </el-dialog>
            <!--列表-->
            <el-table @sort-change="sortChange" :header-cell-class-name="handleHeadAddClass" :data="pageData" border
                      v-loading="tLoading">
                <el-table-column prop="nbr" label="序号" width="130" align="center">
                    <template slot="header">
                        <el-button size="mini" type="" class="el-icon-s-operation" @click="dialogFormVisible=true"/>
                        序号
                    </template>
                </el-table-column>
                <template v-for="(item, index) in tableLabel">
                    <el-table-column
                            v-if="item.show"
                            :key="index"
                            :show-overflow-tooltip="true"
                            :sortable="item.sortable"
                            :prop="item.prop"
                            :width="item.width"
                            :min-width="item.minWidth"
                            :align="item.align"
                            :label="item.label"
                    />
                </template>
                <el-table-column label="操作" width="160" align="right" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" @click="toPage('ddjl',{customerId: scope.row.id})"
                                   title="订单记录" icon="el-icon-tickets"></el-button>
                        <el-button type="success" size="mini"
                                   @click="toPage('gzjl',{customerId: scope.row.id,company:scope.row.company,contact:scope.row.contact,country:scope.row.country})"
                                   title="跟踪记录" icon="el-icon-service"></el-button>
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)"
                                   icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)"
                                   icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"
                               :page-size="filters.pageSize" layout="total, prev, pager, next"
                               :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '客户编辑':'客户新增'" :visible.sync="aVisible" width="80%"
                       :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="180px" ref="formFileds" size="small">
                    <el-form-item label="公司名" prop="company" class="inlineForm w450">
                        <el-input clearable v-model="formData.company"></el-input>
                    </el-form-item>
                    <el-form-item label="公司类型" prop="companyType" class="inlineForm w450">
                        <el-input clearable v-model="formData.companyType"></el-input>
                    </el-form-item>
                    <el-form-item label="客户类别" prop="customerTypeId" class="inlineForm w450">
                        <el-select clearable size="small" filterable v-model="formData.customerTypeId"
                                   placeholder="请选择客户类别">
                            <el-option v-for="item in typeOption" :label="item.name" :value="item.id"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户等级" prop="levelId" class="inlineForm w450">
                        <el-select clearable size="small" filterable v-model="formData.levelId" placeholder="请选择客户等级">
                            <el-option v-for="item in levelOption" :label="item.name" :value="item.id"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跟踪状态" prop="customerTrackStatusId" class="inlineForm w450">
                        <el-select clearable size="small" filterable v-model="formData.customerTrackStatusId"
                                   placeholder="请选择跟踪状态">
                            <el-option v-for="item in statusOption" :label="item.name" :value="item.id"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户状态" prop="customerStatusId" class="inlineForm w450">
                        <el-select clearable size="small" filterable v-model="formData.customerStatusId"
                                   placeholder="请选择客户状态">
                            <el-option v-for="item in customerStatusOption" :label="item.name" :value="item.id"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <!--                    <el-form-item label="产品类型" prop="productTypeId" class="inlineForm w450">-->
                    <!--                        <el-select clearable size="small" filterable v-model="formData.productTypeId" placeholder="请选择产品类别">-->
                    <!--                            <el-option v-for="item in productTypeOption" :label="item.name" :value="item.id" :key="item.id"></el-option>-->
                    <!--                        </el-select>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="客户来源" prop="customerSourceId" class="inlineForm w450">
                        <el-select clearable size="small" filterable v-model="formData.customerSourceId"
                                   placeholder="请选择客户来源">
                            <el-option v-for="item in sourceOption" :label="item.name" :value="item.id"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contact" class="inlineForm w450">
                        <el-input clearable v-model="formData.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="电话/座机" prop="tel" class="inlineForm w450">
                        <el-input clearable v-model="formData.tel"></el-input>
                    </el-form-item>
                    <el-form-item label="其他联系方式" prop="otherContact" class="inlineForm w450">
                        <el-input clearable v-model="formData.otherContact"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email" class="inlineForm w450">
                        <el-input clearable v-model="formData.email"></el-input>
                    </el-form-item>
                    <el-form-item label="国家" prop="country" class="inlineForm w450">
                        <el-input clearable v-model="formData.country"></el-input>
                    </el-form-item>
                    <el-form-item label="网址" prop="website" class="inlineForm w450">
                        <el-input clearable v-model="formData.website"></el-input>
                    </el-form-item>
                    <el-form-item label="常采购产品/咨询产品" prop="products" class="inlineForm w450">
                        <el-input clearable v-model="formData.products"></el-input>
                    </el-form-item>
                    <el-form-item label="WhatsApp" prop="whatsApp" class="inlineForm w450">
                        <el-input clearable v-model="formData.whatsApp"></el-input>
                    </el-form-item>
                    <el-form-item label="主要沟通方式" prop="communication" class="inlineForm w450">
                        <el-input clearable v-model="formData.communication"></el-input>
                    </el-form-item>
                    <el-form-item label="公司成立时间" prop="companyEstablishTime" class="inlineForm w450">
                        <el-date-picker size="small" v-model="formData.companyEstablishTime"
                                        type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="年采购次数" prop="annualPurchaseNumber" class="inlineForm w450">
                        <el-input clearable v-model="formData.annualPurchaseNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="年采购量" prop="annualPurchaseAmount" class="inlineForm w450">
                        <el-input clearable v-model="formData.annualPurchaseAmount"></el-input>
                    </el-form-item>
                    <el-form-item label="阿里ID" prop="aliId" class="inlineForm w450">
                        <el-input clearable v-model="formData.aliId"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input clearable type="textarea" :rows="2" v-model="formData.remark"></el-input>
                    </el-form-item>
                    <!--                    <el-form-item label="名片" prop="visitingCard">-->
                    <!--                        <el-upload-->
                    <!--                            ref="upload"-->
                    <!--                            class="upload-demo"-->
                    <!--                            :action="root + uploadUrl"-->
                    <!--                            :on-remove="handleRemove"-->
                    <!--                            :on-success="handleSuccess"-->
                    <!--                            :before-upload="beforeUpload"-->
                    <!--                            :file-list="fileList"-->
                    <!--                            :limit="1"-->
                    <!--                            :headers="{'username': username }"-->
                    <!--                            list-type="picture"-->
                    <!--                            >-->
                    <!--                            <el-button size="small" type="primary">点击上传</el-button>-->
                    <!--                            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>-->
                    <!--                        </el-upload>-->
                    <!--                    </el-form-item>-->
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary"
                                   @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)"
                                   :loading="bLoading">提交
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import axios from 'axios'
    import qs from 'qs'

    export default {
        name: 'khlb',
        data() {
            return {
                pageUrl: '/customer/list/page',
                updateUrl: '/customer/saveOrUpdate',
                addUrl: '/customer/saveOrUpdate',
                deleteUrl: '/customer/remove',
                exportUrl: '/customer/export',
                exportTemplateUrl: '/customer/exportTemplate',
                importUrl: '/customer/import',
                sortField: {},
                dialogFormVisible: false,
                filters: {
                    pageSize: 10,
                    pageIndex: 1,
                    company: '',
                    customerTypeId: '',
                    customerTrackStatusId: '',
                    levelId: '',
                    customerSourceId: '',
                    customerStatusId: '',
                    lastTrackTimeStart: '',
                    lastTrackTimeEnd: '',
                    pageSorts: [],
                    openSea: ''
                },

                formData: {
                    annualPurchaseAmount: "",
                    annualPurchaseNumber: "",
                    communication: '',
                    company: '',
                    companyType: '',
                    companyEstablishTime: '',
                    contact: '',
                    country: '',
                    customerSourceId: '',
                    customerTypeId: '',
                    email: '',
                    id: '',
                    levelId: '',
                    otherContact: '',
                    products: '',
                    remark: '',
                    tel: '',
                    website: '',
                    whatsApp: '',
                    visitingCard: '',
                    aliId: '',
                    customerTrackStatusId: '',
                    customerStatusId: '',
                    notCheck: 0
                },
                formRules: {
                    company: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'}
                    ],
                    levelId: [
                        {required: true, message: '请选择客户登记', trigger: 'blur'}
                    ],
                    customerTypeId: [
                        {required: true, message: '请选择客户类型', trigger: 'blur'}
                    ],
                    customerTrackStatusId: [
                        {required: true, message: '请选择跟踪状态', trigger: 'blur'}
                    ],
                    customerStatusId: [
                        {required: true, message: '请选择客户状态', trigger: 'blur'}
                    ],
                    productTypeId: [
                        {required: true, message: '请选择产品类型', trigger: 'blur'}
                    ],

                },
                fileList: [],
                tableLabel: [
                    {label: '跟踪情况', prop: 'trackRemindStatusStr', align: 'center', show: true},
                    {label: '客户等级', prop: 'levelName', show: true},
                    {label: '客户类型', prop: 'customerTypeName', show: true},
                    {label: '跟踪状态', prop: 'customerTrackStatusName', show: true},
                    {label: '客户状态', prop: 'customerStatusName', show: true},
                    {label: '国家', prop: 'country', show: true},
                    {label: '公司名', prop: 'company', minWidth: '150', show: true},
                    {label: '公司类型', prop: 'companyType', show: true},
                    {label: '订单总金额', prop: 'amounts', sortable: 'custom', show: true, minWidth: '100'},
                    {label: '主要联系人', prop: 'contact', minWidth: '120', show: true},
                    {label: '客户来源', prop: 'customerSourceName', show: true},
                    {label: '常采购产品/咨询产品', prop: 'products', show: true},
                    {label: '跟踪日期', prop: 'lastTrackTime', sortable: 'custom', align: 'center', show: true, minWidth: '100'},
                    {label: '即将掉入公海时间', prop: 'soonOpenSeaTime',sortable: 'custom', align: 'center', show: true, minWidth: '150'},
                    {label: '掉入公海时间', prop: 'openSeaTime', sortable: 'custom', align: 'center', show: true, minWidth: '150'},
                    {label: '邮箱', prop: 'email', minWidth: '150', show: true},
                    {label: 'WhatsApp', prop: 'whatsApp', show: true},
                    {label: '电话/座机', prop: 'tel', minWidth: '150', show: true},
                    {label: '其他联系方式', prop: 'otherContact', minWidth: '100', show: true},
                    {label: '主要沟通方式', prop: 'communication', show: true},
                    // { label: '备注',prop: 'remark',show:true},
                    {label: '网站', prop: 'website', show: true},
                    {label: '阿里ID', prop: 'aliId', show: true},
                    // { label: '公司成立时间',prop: 'companyEstablishTime',align: 'center',show:true},
                    // { label: '年采购次数',prop: 'annualPurchaseNumber',sortable: 'custom',minWidth:'100',align: 'right',show:true},
                    // { label: '年采购量',prop: 'annualPurchaseAmount',sortable: 'custom',minWidth:'100',align: 'right',show:true},
                ]
            }
        },
        computed: {
            ...mapGetters(['levelOption', 'typeOption', 'sourceOption', 'productTypeOption', 'statusOption', 'username', 'customerStatusOption',])
        },
        methods: {
            capitalize(s) {
                let words = s.split("");  //将字符串进行拆分
                let reg = /^[A-Z]+$/;    //正则A-Z
                for (let i = 1; i < words.length; i++) {
                    if (reg.test(words[i])) {   //判断单个字符是否大写
                        words[i] = '_' + words[i].toLowerCase()
                    }
                }
                return words.join('');
            },
            sortChange({order, prop}) {
                // 触发的排序和缓存的排序相同时，取消该字段的排序
                if (!order || this.sortField[prop] === order) {
                    this.sortField[prop] = null
                } else {
                    this.sortField[prop] = order
                }
                this.filters.pageSorts = []
                let direction = ''
                for (let i in this.sortField) {
                    if (this.sortField[i] == 'ascending') {
                        direction = 'ASC'
                    } else if (this.sortField[i] == 'descending') {
                        direction = 'DESC'
                    }
                    i = this.capitalize(i)
                    this.filters.pageSorts.push({
                        "column": i,
                        "direction": direction
                    })
                }
                this.getPage() //调用后端查询接口
            },
            handleHeadAddClass({column}) {
                if (this.sortField[column.property]) {
                    column.order = this.sortField[column.property]
                }
            },
            beforeUpload(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!file.name.includes("jpg") && !file.name.includes("png") && !file.name.includes("jpeg")) {
                    this.$message.warning("只能上传jpg/png文件");
                    return false;
                }
                if (!isLt5M) {
                    this.$message.error('上传头像图片大小不能超过 5MB!');
                    return false;
                }
            },
            formSubmit(url = this.addUrl, para = this.formData, afterFun = this.getPage) {
                this.$refs.formFileds.validate((valid) => {
                    if (valid) {
                        if (this.formData.notCheck == 0) {
                            this.$confirm('确认保存或提交吗？', '提示', {}).then(() => {
                                this.bLoading = true
                                this.request2(url, para, (data) => {
                                    this.$message({message: '保存或提交成功', type: 'success'})
                                    this.aVisible = false
                                    if (afterFun !== null)
                                        afterFun()
                                }, 'postJson', null, (res) => {
                                    if (res.data.code == 405) {
                                        this.$message.error('登录超时，请重新登录')
                                        this.toPage('login')
                                    } else if (res.data.code == 400) {
                                        this.handleNext(url, para, afterFun)
                                    } else {
                                        this.$message({type: 'warning', message: res.data.msg})
                                    }

                                })
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            })
                        } else {
                            this.request2(url, para, (data) => {
                                this.$message({message: '保存或提交成功', type: 'success'})
                                this.aVisible = false
                                if (afterFun !== null)
                                    afterFun()
                            }, 'postJson', null, (res) => {
                                if (res.data.code == 405) {
                                    this.$message.error('登录超时，请重新登录')
                                    this.toPage('login')
                                } else if (res.data.code == 400) {
                                    this.handleNext(url, para, afterFun)
                                } else {
                                    this.$message({type: 'warning', message: res.data.msg})
                                }

                            })
                        }

                    }
                })
            },
            async request2(url, para = {}, success, type = 'postJson', isLoading, error = null) {
                this.bLoading = !isLoading
                this.tLoading = !isLoading
                this.fLoading = !isLoading
                let params = new Object();
                let headers = {}
                if (sessionStorage.getItem('loginData')) {
                    headers = {'username': JSON.parse(sessionStorage.getItem('loginData')).username}
                }
                if (type == 'post') params = qs.stringify(para);
                if (type == 'postJson') {
                    params = para
                    type = 'post';
                }
                ;
                if (type == 'get') {
                    params.params = para;
                    params.headers = headers;
                }
                await axios[type](this.root + url, params, {headers: headers}).then((res) => {
                    if (res.data.code == 200) {
                        success(res.data.data)
                    } else {
                        error(res)
                    }
                    setTimeout(() => {
                        this.bLoading = false
                        this.tLoading = false
                        this.fLoading = false
                    }, 300)
                }, (res) => {
                    this.$message.error('网络错误，请稍后再试')
                    this.bLoading = false
                    this.tLoading = false
                    this.fLoading = false
                })
            },
            handleNext(url, para, afterFun) {
                this.$confirm('该信息已存在，是否继续保存?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.bLoading = true
                    this.formData.notCheck = 1
                    this.formSubmit(url, para, afterFun)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                })
            },
            handleForm(type, row) {
                this.formData.notCheck = 0
                this.aVisible = true;
                this.$nextTick(() => {
                    this.$refs.formFileds.resetFields();
                    this.formData.visitingCard = ''
                    if (this.$refs.upload) {
                        this.$refs.upload.clearFiles();
                        this.fileList = [];
                    }
                    if (type) {
                        this.saveType = 1
                        this.formData.id = row.id
                        this.mergeObject(this.formData, row)
                        if (row.visitingCard) {
                            this.fileList.push({
                                name: row.visitingCard,
                                url: row.visitingCard
                            })
                        }
                    } else {
                        this.saveType = 0
                        delete this.formData.id
                        this.formData.customerTypeId = ''
                        this.formData.customerTrackStatusId = ''
                    }
                })
            },
        },
        created() {
            this.getPage()
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>